import axios from "axios";

const axiosHttp = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

const createQrForm = (formData) => {
    return axiosHttp
    .post("/feedback/createQrTicket", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    })
    .then( (res) => {
        const resp = res.data;
        if(res.error) {
            console.log(resp.error);
        } else {
            return resp;
        }
    })
    .catch( (err) => {
        return err;
    })
};

const filterObject = (obj, excludeKey) => {
    return Object.keys(obj).reduce((acc, key) => {
      if (key !== excludeKey) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };

export {
    createQrForm,
    filterObject,
};